module.exports = __webpack_public_path__ + "static/cart-management-4ce3aac784468988bf96b5fa06d027ca.png";